<template>
  <v-card class="clubbing-card">
    <h2>Trip Clubbing</h2>
    <div class="clubbing-list">
      <table class="clubbing-table">
        <thead>
          <tr class="clubbing-header">
            <th class="check-block">
              <v-checkbox dense hide-details v-model="allSelectedStatus" @change="checkAll" label="Select All"></v-checkbox>
            </th>
            <th>Trip ID</th>
            <th>Crew Details</th>
            <th class="content-block">{{ tripDetails.serviceType === 1 ? "Pickup" : "Drop" }} Address</th>
            <th>Drop Off Time</th>
            <th>Reporting Time</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="trip in tripList">
            <template v-if="trip.employees">
              <tr v-for="(user, index) in trip.employees" :key="`${trip.id}-${index}`">
                <td v-if="index === 0" class="check-block" :rowspan="trip.employees.length"><v-checkbox dense hide-details v-model="trip.selectedStatus"></v-checkbox></td>
                <td v-if="index === 0" class="text-center" :rowspan="trip.employees.length">{{ trip.id ? trip.id : trip.tripId }}</td>
                <td class="text-center">
                  <span>{{ user.name }}</span><br>
                  <span class="extra-row">Crew ID: {{ user.crewId }}</span><br>
                  <span class="flight-info" v-if="user.flightInfo">{{ checkFlightInfo(user) }}</span>
                </td>
                <td class="text-center">
                  <span>{{ user.address }}</span>
                </td>
                <td class="text-center">
                  <span v-if="trip.tripType !== 'DropOff'"> {{ formatDateAndTime(user.reportingTime, "date", "drop") }}</span>
                  <span v-if="trip.tripType !== 'DropOff'"> {{ formatDateAndTime(user.reportingTime, "time", "drop") }}</span>
                  <span v-else>---</span>
                </td>
                <td class="text-center">
                  <span> {{ formatDateAndTime(user.reportingTime, "date", "rep") }}</span>
                  <span>
                    {{ formatDateAndTime(user.reportingTime, "time", "rep") }}
                  </span>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
      <!-- <tr v-for="(trip, index) in tripList" :key="index" class="clubbed-trips-row">
            <td class="check-block">
              <v-checkbox dense hide-details v-model="trip.selectedStatus"></v-checkbox>
            </td>
            <td># {{ trip.id }}</td>
            <td>
              <tr>
                <td v-for="(employee, employeeIndex) in trip.employees" :key="employeeIndex">
                  {{ employee.name }}<br />
                  <span class="extra-info">Crew ID: {{ employee.crewId }}</span>
                </td>
                 <td v-for="(employee, employeeIndex) in trip.employees" :key="employeeIndex">
                  {{ employee.address }}
                </td>
                <td v-for="(employee, employeeIndex) in trip.employees" :key="employeeIndex">
                  {{ formatDateAndTime(employee.reportingTime, "date", "drop") }}<br />
                  {{ formatDateAndTime(employee.reportingTime, "time", "drop") }}

                </td>
              </tr>
              <!-- <ul class="sub-list crew-details">
                <li v-for="(employee, employeeIndex) in trip.employees" :key="employeeIndex">
                  {{ employee.name }}<br />
                  <span class="extra-info">Crew ID: {{ employee.crewId }}</span>
                </li>
              </ul> -->
      <!-- </td> -->
      <!-- <td> -->
      <!-- <ul class="sub-list pickup-address">
                <li v-for="(employee, employeeIndex) in trip.employees" :key="employeeIndex">
                  {{ employee.address }}
                </li>
              </ul> -->
      <!-- </td> -->
      <!-- <td> -->
      <!-- <ul :class="{ 'hide-block': tripDetails.serviceType === 2 }" class="sub-list drop-off-time">
                <li v-for="(employee, employeeIndex) in trip.employees" :key="employeeIndex">
                  {{ formatDateAndTime(employee.reportingTime, "date", "drop") }}<br />
                  {{ formatDateAndTime(employee.reportingTime, "time", "drop") }}
                </li>
              </ul> -->
      <!-- </td> -->
      <!-- <td> -->
      <!-- <ul class="sub-list reporting-time">
                <li v-for="(employee, employeeIndex) in trip.employees" :key="employeeIndex">
                  {{ formatDateAndTime(employee.reportingTime, "date", "rep") }}<br />
                  {{ formatDateAndTime(employee.reportingTime, "time", "rep") }}
                </li>
              </ul> -->
      <!-- </td> -->
      <!-- </tr> -->

      <div class="button-block">
        <v-btn color="#147a19" @click="clubTrip" :disabled="!tripList.some((trip) => trip.selectedStatus)  || disableBtn">Club Trips</v-btn>
        <v-btn color="#6d1711" @click="closeDialog">assign individually</v-btn>
          <v-btn color="red" @click="handleUnassign">Cancel</v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
export default {
  name: "TripClubbing",
  props: {
    tripList: Array,
    tripDetails: Object,
    changedPickUpDate: [String, Number],
    disableBtn: Boolean,
  },
  data() {
    return {
      clubFrom: [],

      allSelectedStatus: false,
    };
  },
  mounted() {
    this.tripList.map((trip) => {
      this.$set(trip, "selectedStatus", this.tripList.length > 1 ? false : true);
    }); 
    if (this.tripList.length === 1) this.allSelectedStatus = true;
  },
  methods: {
    handleUnassign()
    {
      this.$emit("unassign", this.tripDetails)
    this.$emit("close-clubbing");
},

    formatDateAndTime(date, type, timeType) {
      if (type === "date") {
        return timeType === "drop" ? moment(date).subtract(20, "minutes").format("DD-MM-YYYY") : moment(date).format("DD-MM-YYYY");
      } else {
        return timeType === "drop" ? moment(date).subtract(20, "minutes").format("HH:mm ") : moment(date).format("HH:mm ");
      }
    },
    checkSelect() {
      this.clubFrom = this.tripList.map((trip) => {
        if (trip.selectedStatus) return trip.tripId;
      });
      this.$emit("check-select", this.clubFrom);
    },
    checkAll() {
      this.tripList.map((trip) => {
        this.$set(trip, "selectedStatus", this.allSelectedStatus);
      });
    },
    clubTrip() {
      this.checkSelect();
    },
    closeDialog() {
      this.$emit("close-clubbing");
    },
  },
};
</script>

<style lang="scss" scoped>
.clubbing-card {
  padding: 15px;
  border-radius: 0;
  h2 {
    text-align: center;
    border-bottom: 1px solid #d5d5d5;
    font-weight: bold;
  }
  .clubbing-list {
    padding: 10px;
    width: 100%;

    .clubbed-trips-row {
      height: 100px;

      font-weight: bolder;
    }

    .clubbing-table {
      width: 100%;
      border-collapse: collapse;

      th,
      td {
        border: 1px solid #e3e3e3;
        padding: 8px;
        font-size: 12px;
        color: black;
        font-weight: bolder;
        text-align: center;
        vertical-align: middle;
      }

      th {
        color: #6a0737 !important;
        font-weight: 600 !important;
      }

      .check-block {
        width: 10%;
        text-align: center;
      }

      .content-block {
        width: 30%;
        word-break: break-word;
        overflow-wrap: break-word;
      }

      td:not(.check-block):not(.content-block) {
        width: 15%;
      }

      .sub-list {
        margin: 0;
        padding: 0 10px;
        list-style-type: none;
        text-align: left;

        li {
          margin-bottom: 20px;
          list-style-type: disc;
          font-weight: 600;
        }
      }

      .crew-details,
      .pickup-address,
      .drop-off-time,
      .reporting-time {
        text-align: left;
      }

      .drop-off-time,
      .reporting-time li {
        text-align: left;
      }

      .extra-info {
        color: #096181c3;
        font-weight: bolder;
      }
      .hide-block {
        visibility: hidden;
      }

      ::v-deep .v-label {
        font-size: 12px;
        color: #6a0737 !important;
        font-weight: 600 !important;
      }

      ::v-deep .v-input--selection-controls {
        margin-top: 0;
        padding-top: 0;
      }
    }
  }

  .button-block {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin: 20px 0;

    .v-btn {
      color: #ffffff;
      font-weight: bold;
    }
  }
  //  .clubbed-trips {

  //  }
}
</style>
